import React, { useState, useEffect } from "react";
import Baseurl from "../../../Baseurl";
import { Table, Col, Card, Spinner, Modal } from "react-bootstrap";
import axios from "axios";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
export default function ViewAddons(props) {
  const { id, val } = props.match.params;
  const history = useHistory();
  const [restaurantDetails, setRestaurantDetails] = useState("");
  const [restaurant, setRestaurant] = useState("");
  const [reason, setReason] = useState("");
  const [spinnerAccept, setSpinnerAccept] = useState(false);
  const [show1, setShow1] = useState(false);
  const [rejectStatus, setRejectStatus] = useState(false);
  const [viewimage, setViewImage] = useState();
  const handleClose1 = () => {
    setShow1(false);
  };
  function getData() {
    axios
      .get(`${Baseurl.baseurl4}/go-food/get-item-addon-category-by-id/${id}`)
      .then((res) => {
        console.log("Addons details", res.data.getItemAddonCategory);
        let restoArr = [];
        if (res.data.status) {
          setRestaurant(res.data.getItemAddonCategory);
          restoArr.push(
            {
              name: "Item Name",
              val: res.data.getItemAddonCategory.RAddonCategoryName,
            },
            {
              name: "Description",
              val: res.data.getItemAddonCategory.RAddonCategoryDescription,
            },
            {
              name: "Selection",
              val: res.data.getItemAddonCategory.RAddonCategorySelection,
            }
          );

          setRestaurantDetails(restoArr);
        }
      });
  }
  useEffect(() => {
    getData();
  }, []);
  function acceptAddons() {
    setSpinnerAccept(true);
    const params = {
        aID: id,
      // RegistrationToken:
    };
    axios
      .put(
        `${Baseurl.baseurl4}/go-food-super-admin/approve-addon-details`,
        params
      )
      .then((res) => {
        if (res.data.status) {
          swal("Accepted", res.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          setSpinnerAccept(false);
          history.push("/All-Addons");
        } else {
          swal("Oops", res.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        // if (err.toString() === "Error: Network Error") {
        //   history.push("/offline");
        // } else {
        //   history.push("/400");
        // }
      });
  }
  
  function rejectItems() {
    const params = {
        aID: id,
      reason: reason,
      // RegistrationToken:
    };
    axios
      .put(
        `${Baseurl.baseurl4}/go-food-super-admin/reject-addon-details`,
        params
      )
      .then((res) => {
        if (res.data.status) {
          swal("Rejected", res.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          history.push("/Applied-Addons");
        } else {
          swal("Oops", res.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        // if (err.toString() === "Error: Network Error") {
        //   history.push("/offline");
        // } else {
        //   history.push("/400");
        // }
      });
  }
  return (
    <div>
      <Col lg={12}>
        <Modal size="lg" show={show1} onHide={handleClose1}>
          <Modal.Body>
            {rejectStatus ? (
              <div className="row">
                <div className="col-sm-2 mt-2">
                  <label>Reason</label>
                </div>
                <div className="col-sm-8 ">
                  <textarea
                    type="text"
                    className="form-control"
                    id="val-username"
                    name="val-username"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    placeholder="Enter reason"
                  />
                </div>
              </div>
            ) : (
              <div>
                <img
                  alt=""
                  style={{
                    resizeMode: "cover",
                    width: "100%",
                    height: "100%",
                  }}
                  className="playerProfilePic_home_tile"
                  src={viewimage}
                />
              </div>
            )}
          </Modal.Body>
          {rejectStatus && (
            <Modal.Footer>
              <button
                onClick={() => {
                  rejectItems();
                }}
                className="btn btn-danger"
              >
                Reject
              </button>
            </Modal.Footer>
          )}
        </Modal>
        <Card
          style={{
            color: "white",
            background:
              "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
          }}
        >
          <Card.Header>
            <div></div>
            <button
              className="btn btn-primary "
              onClick={() => {
                history.goBack();
              }}
            >
              Back
            </button>
          </Card.Header>
          <Card.Body>
            <Table className="text-white">
              {restaurantDetails &&
                restaurantDetails.map((val) => {
                  return (
                    <tr>
                      <td>{val.name}</td>
                      <td>{val.val}</td>
                    </tr>
                  );
                })}
            </Table>
            <div className="row mt-4">
              <div className="col-sm-3">
                <label>Item Addons</label>
              </div>
              <div className="col-sm-9" >
                <div className="row text-primary text-center">
                <div className="col-sm-4">Name</div>
                          <div className="col-sm-4">Category</div>
                          <div className="col-sm-4">Price</div>
                </div>
                <div className="row text-center">

                  {restaurant.RAddonItem &&
                    restaurant.RAddonItem.map((val) => {
                      return (
                        <>
                          <div className="col-sm-4">{val.ItemName}</div>
                          <div className="col-sm-4">{val.ItemCategory}</div>
                          <div className="col-sm-4">{val.ItemPrice} ₹</div>
                        </>
                      );
                    })}
                </div>
              </div>
            </div>
          </Card.Body>
          {!restaurant.Verified && (
            <Card.Footer>
              {spinnerAccept ? (
                <div className="ml-auto mr-2 float-right">
                  <Spinner animation="border" variant="primary" />
                </div>
              ) : (
                <button
                  className="btn btn-primary float-right"
                  onClick={() => {
                    acceptAddons();
                  }}
                >
                  Accept
                </button>
              )}

              <button
                onClick={() => {
                  setRejectStatus(true);
                  setShow1(true);
                }}
                className="btn btn-danger text-center "
              >
                Reject
              </button>
            </Card.Footer>
          )}
        </Card>
      </Col>
    </div>
  );
}
